var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"Macmonitor"},[_c('div',{style:(_vm.contentstyle)},[_c('el-image',{staticStyle:{"width":"100%","height":"100%"},attrs:{"fit":"fill","src":_vm.image}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }